import { FC } from "react"
import { Form, Modal, Select } from "antd"
import { useStore } from "stores/utils/use-store"
import { SubmitCancelButtons, FormElement } from "components"
import { BuffPlayPopupType } from "domains/accountsBuffPlay/api/popups.call"

export const UpsertPopupBuffPlayComponent: FC<{
  visible: boolean;
  onClose: () => void;
  onSubmit: (el: { type: BuffPlayPopupType; text: string }) => void;
}> = ({ visible, onClose, onSubmit }) => {
  const { dataStore: { accountDetailsStoreBuffPlay } } = useStore()

  return (
    <Modal visible={visible} title="Upsert a Popup" footer={null} onCancel={() => onClose()}>
      <Form onFinish={onSubmit}>
        <Form.Item
          label="Popup type"
          name="type"
          rules={[
            {
              required: true,
              message: "Please select type!",
            },
          ]}
        >
          <Select>
            {Object.entries(BuffPlayPopupType).map((item, id) => (
              <Select.Option value={item[1]} key={id}>
                {item[1]}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <FormElement
          type="text"
          label="Text"
          name="text"
          initialValue=""
          rules={[{ required: true, message: "Please enter text!" }]}
          props={{ style: { width: "100%" } }}
        />
        <SubmitCancelButtons onClose={onClose} isLoading={accountDetailsStoreBuffPlay.isLoading} />
      </Form>
    </Modal>
  )
}
